<template>
  <label
    :for="id"
    :class="{'inline': inline, 'list': inlist, 'disabled': disabled}"
    @click="$emit('click')"
  >
    <div
      class="uiRadio"
      :class="{'checked': (model && Array.isArray(model) && model.indexOf(value) > -1) || (trueVal && trueVal === true)}"
    ></div>
    <input
      :disabled="disabled"
      for="label"
      type="checkbox"
      :value="value"
      v-model="model"
      :name="name"
      @change="update"
      :id="id"
    >
    {{label}}
  </label>
</template>

<script>
export default {
  name: "Checkbox",
  props: [
    "label",
    "name",
    "model",
    "value",
    "id",
    "inline",
    "checked",
    "inlist",
    "disabled",
    "trueVal"
  ],
  data() {
    return {
      checked: false
    };
  },
  methods: {
    update() {
      this.$emit("change", this.model);
    }
  },
  created() {
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/style.less";

label {
  position: relative;
  padding-right: 29px;
  margin-bottom: 0px;
  display: block;
}

.inlist {
  margin-top: 8px;
}

.inline {
  margin-left: 15px;
  display: inline-block;
  vertical-align: top;
}

.uiRadio {
  border: @border;
  width: 15px;
  height: 15px;
  position: absolute;
  right: 0px;
  top: 4px;
  background: #fff;
  box-shadow: inset 0px 0px 1px 5px #fff;
  transition: all 0.2s ease-in;
}

.checked {
  border-color: @grey-dark;
  background: @blue-dark;
  box-shadow: inset 0px 0px 0px 0px #fff;
}

.disabled {
  opacity: 0.8;
  color: #666;
  .uiRadio {
    border-color: #666;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/uiCheckbox.vue